// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const BookingStepFour = registerClientReference(
    function() { throw new Error("Attempted to call BookingStepFour() from the server but BookingStepFour is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/booking/BookingStepFour.tsx",
    "BookingStepFour",
);
